import LegalLayout from "@/components/legal/legal-layout"
import content from "@/content/legal/ley-california.md?raw"

export default function CaliforniaLaw() {
  return <LegalLayout title="Ley de California" content={content} />
}
